import { accommodationSubTypeIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/accommodation-types/accommodation-sub-type-id";
import { amenityIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity-id";
import { capacityZodObject } from "@@/shared/acquire/resources/resource-accommodation/capacity";
import { resourceFoundationIdZodSchema } from "@@/shared/acquire/resources/resource-foundation-id";
import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { storageItemImageIdZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const resourceAccommodationEditCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("RESOURCE_ACCOMMODATION_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    resourceOrResourceFoundationId: resourceIdZodSchema.or(
        resourceFoundationIdZodSchema,
    ),
    title: requiredTranslatableZodSchema,
    subtitle: translatableZodSchema,
    description: translatableZodSchema,
    providerId: providerIdZodSchema,
    amenityIds: z.array(amenityIdZodSchema),
    imageIds: z.array(storageItemImageIdZodSchema),
    capacity: capacityZodObject,
    accommodationTypeSyncedHash: z.string().optional(),
    disabledAccommodationSubTypeIds: z.array(accommodationSubTypeIdZodSchema),
    allowMultipleCheckIns: z.boolean(),
    checkInEnabled: z.boolean(),
});
type ResourceAccommodationEditCommand = z.infer<
    typeof resourceAccommodationEditCommandZodObject
>;

const resourceAccommodationEditCommandFactoryParamsZodObject =
    resourceAccommodationEditCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof resourceAccommodationEditCommandFactoryParamsZodObject
>;

const resourceAccommodationEditCommandFactory = (params: FactoryParams) => {
    const resourceAccommodationEditCommand: ResourceAccommodationEditCommand = {
        ...params,
        _id: generateId({ prefix: "resource_accommodation_edit_command__" }),
        _type: "RESOURCE_ACCOMMODATION_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return resourceAccommodationEditCommand;
};

export {
    resourceAccommodationEditCommandFactory,
    resourceAccommodationEditCommandFactoryParamsZodObject,
    resourceAccommodationEditCommandZodObject,
};
export type {
    ResourceAccommodationEditCommand,
    FactoryParams as ResourceAccommodationEditCommandFactoryParams,
};
